import {
  ACTIVE_CUSTOMER_DISPLAY,
  ENABLE_CUSTOMER_DISPLAY,
  CUSTOMER_DISPLAY_QUOTE_STATE,
  CUSTOMER_DISPLAY_QUOTE_DISCOUNT,
  LOGOUT_USER,
} from 'redux/types'

const initState = {
  isActiveCustomerDisplay: false,
  isCustomerDisplayEnabled: null,
  quoteDetailState: null,
  quoteShowDiscount: null,
}

export default function customerDisplayReducer(state = initState, action) {
  switch (action.type) {
    case CUSTOMER_DISPLAY_QUOTE_STATE:
      return { ...state, quoteDetailState: action.payload }

    case CUSTOMER_DISPLAY_QUOTE_DISCOUNT:
      return { ...state, quoteShowDiscount: action.payload }

    case ACTIVE_CUSTOMER_DISPLAY:
      return {
        ...state,
        isActiveCustomerDisplay: action.payload,
      }

    case ENABLE_CUSTOMER_DISPLAY:
      return {
        ...state,
        isCustomerDisplayEnabled: action.payload,
      }

    case LOGOUT_USER:
      return { ...initState }

    default:
      return state
  }
}
